module.exports = __webpack_public_path__ + "img/event-3.f671fe6f.png";